export default __webpack_public_path__ + "static/media/about-zl-2.f573642d.jpg";